import API from "../../../utils/api";

export const getSizeCategoryMeasurementsApi = async (filters) => {
    const response = await API.get(`size-category-measurement/size-category-measurement`, { params: filters });
    return { response };
};

export const addSizeCategoryMeasurementApi = async (data) => {
    const response = await API.post(`size-category-measurement/size-category-measurement`, data);
    return { response };
};

export const updateSizeCategoryMeasurementApi = async (data, id) => {
    const response = await API.put(`size-category-measurement/size-category-measurement/${id}`, data);
    return { response };
};

export const deleteSizeCategoryMeasurementApi = async (id) => {
    const response = await API.delete(`size-category-measurement/size-category-measurement/${id}`);
    return { response };
};

export const categoryAutoSearchApi = async (params) => {
    const response = await API.get(`size-category-measurement/category-auto-search`, { params });
    return { response };
};

export const sizeAutoSearchApi = async (params) => {
    const response = await API.get(`size-category-measurement/size-auto-search`, { params });
    return { response };
};

export const getMeasurementTypesApi = async () => {
    const response = await API.get(`size-category-measurement/measurement-types`);
    return { response };
};

export const getMeasurementUnitsApi = async () => {
    const response = await API.get(`size-category-measurement/measurement-units`);
    return { response };
};

export const getCategoryMeasurementTypesApi = async (params) => {
    const response = await API.get(`size-category-measurement/category-measurement-types`, { params });
    return { response };
};

export const sellerAutoSearchApi = async (params) => {
    const response = await API.get(`size-category-measurement/seller-auto-search`, { params });
    return { response };
};

export const brandAutoSearchApi = async (params) => {
    const response = await API.get(`size-category-measurement/brand-auto-search`, { params });
    return { response };
};

export const getDefaultSellerApi = async () => {
    const response = await API.get(`size-category-measurement/default-seller`);
    return { response };
};

export const importSizeCategoryMeasurementsApi = async (formData) => {
    const response = await API.post(`size-category-measurement/import`, formData, {
        'content-type': 'multipart/form-data'
    });
    return { response };
};

export const downloadSampleCsvApi = async () => {
    const response = await API.get(`size-category-measurement/sample-csv`, {
        responseType: 'blob'
    });
    return { response };
};

export const exportSizeCategoryMeasurementsApi = async (params) => {
    const response = await API.get(`size-category-measurement/export`, {
        params,
        responseType: 'blob'
    });
    return { response };
};

export const getSyncStatusApi = async () => {
    const response = await API.get(`size-category-measurement/sync-status`);
    return { response };
};

export const syncNowApi = async () => {
    const response = await API.post(`size-category-measurement/sync-now`);
    return { response };
};
